<div class="page-wraper" appSpin [spinnerConfig]="spinnerConfig()">
  <header class="d-flex align-items-center justify-content-between bg-primary p-3 mb-2" *ngIf="router.url=='/dailyload-details'">
    <div class="header-left d-flex flex-row align-items-center gap-8">
      <ngx-avatars initialsSize="1" size="22" bgColor="#ffffff" fgColor="#3373a5" [name]="selectedEngagementDataCopy.engagementtype" [round]="false" textSizeRatio="1.4"></ngx-avatars>
      <h6 class="title text-white" title="{{selectedEngagementDataCopy.engagementtype}}" *ngIf="selectedEngagementDataCopy.pengagementtypeid != 1">
        {{selectedEngagementDataCopy.engagementtype}}
      </h6>
      <h6 class="title text-white" title="COM" *ngIf="selectedEngagementDataCopy.pengagementtypeid == 1">COM</h6>
      <p class="text-white">Engagement Name: <b>{{engagementName}}</b></p>
    </div>

    <div class="header-middle">
      <p class="text-white">Client Name: <b>{{clientName}}</b></p>
    </div>

    <div class="header-right">
      <p class="text-white">Year End Date: <b>{{yearEnd| appCountableTimeZone:'MMM dd, yyyy':'UTC'}}</b></p>
    </div>
  </header>

  <div class="page-title-block bg-white pt-0">
    <div class="vertical-items justify-content-between align-items-center">
      <div class="vertical-items gap-8">
        <button mat-button class="button-text" *ngIf="router.url != '/dailyload-details'" (click)="viewTrialBalance()" class="arrow-back-btn">
          <i class="fa-regular fa-arrow-left"></i>
        </button>
        <h1 class="title h3" *ngIf="router.url != '/dailyload-details'">TB Check</h1>
        <h1 class="title h3" *ngIf="router.url == '/dailyload-details'">TB Check</h1>
      </div>
      <p>Last updated on: <span class="fw-semibold">{{lasupdatedate | timeago}}</span></p>
    </div>
    <div class="vertical-items align-items-end justify-content-between flex-wrap flex-sm-nowrap">
      <mat-form-field class="fixed-label" floatLabel="always">
        <mat-label>Entity Name</mat-label>
        <mat-select placeholder="Select" [(ngModel)]="selectedEntityName" disabled>
          <mat-option title="{{selectedEngagementDataCopy.clientName}}" [value]="selectedEngagementDataCopy.clientName">
            {{selectedEngagementDataCopy.clientName}}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field class="fixed-label" floatLabel="always">
        <mat-label>Year End Date</mat-label>
        <mat-select placeholder="Select" [(ngModel)]="selectedYear" disabled>
          <mat-option title="{{selectedEngagementDataCopy.yearEnd | appCountableTimeZone:'MMM dd, yyyy':'UTC'}}" [value]="selectedEngagementDataCopy.yearEnd | appCountableTimeZone:'MMM dd, yyyy':'UTC'">
            {{selectedEngagementDataCopy.yearEnd | appCountableTimeZone:'MMM dd, yyyy':'UTC'}}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <div class="button-group ms-auto export-check-btn">
          <button mat-button mat-stroked-button color="dark" class="button-medium" [matMenuTriggerFor]="exportItemMenu"
                  title="Export" [disabled]="accessPermissions?.hasExportData != true || recentStatus == 1"
                  [ngClass]="{'accept-reject-btns-hide': recentStatus == 5 || recentStatus == 6}">
            <span class="flexbox-row gap-8">
              <i class="fa-regular fa-file-export"></i>
                <span class="button-label">Export</span>
                <i class="fa-solid fa-angle-down fs-15"></i>
            </span>
        </button>
        <mat-menu #exportItemMenu="matMenu" #beforeMenu="matMenu" xPosition="before">
            <button [disabled]="accessPermissions?.hasExportData != true || recentStatus == 1" mat-menu-item
                    title="Export PDF" (click)="exportTBCheckPdf()">Export PDF
            </button>
        </mat-menu>
        <ng-container *ngIf="recentStatus == 1">
          <button mat-button mat-stroked-button color="dark" class="button-medium" [disabled]="recentStatus != 1" title="Reject" (click)="rejectDialogOpen()">
            <span class="flexbox-row gap-8">
                <i class="fa-regular fa-xmark text-error"></i>
                <span class="button-label">Reject</span>
            </span>
          </button>
          <button mat-button mat-stroked-button color="dark" class="button-medium" [disabled]="recentStatus != 1" title="Accept" (click)="saveResponse(5)">
            <i class="fa-regular fa-check text-success"></i>
            <span class="button-label">Accept</span>
          </button>
        </ng-container>
      </div>
    </div>
  </div>

  <div class="content-block-main daily-loads-container">
    <div class="card daily-loads-container-body">
      <div class="daily-loads-static-item daily-loads-changes-items">
        <ul>
          <li>
            <div class="daily-loads-header empty-header bg-gray-50"></div>
            <div class="daily-loads-body">
              <table mat-table [dataSource]="trialbalanceData" class="table-countable parent-empty-header">
                <!-- Account Column -->
                <ng-container matColumnDef="account">
                  <th class="account-col" mat-header-cell *matHeaderCellDef title="Acc No.">ACC NO</th>
                  <td class="account-col position-relative" mat-cell *matCellDef="let element" title="{{element.accountcode}}">
                    <ng-container *ngIf="element.highlight == 1 || element.highlight == 10 || element.highlight == 11">
                      <span class="status-badge" [ngClass]="{'bg-error': element.highlight == 1 || element.highlight == 11, 'bg-success': element.highlight == 10}">
                        <span class="status-badge-label">
                          <ng-container *ngIf="element.highlight == 1">CHG</ng-container>
                          <ng-container *ngIf="element.highlight == 10">ACTD</ng-container>
                          <ng-container *ngIf="element.highlight == 11">RJTD</ng-container>
                        </span>
                      </span>
                    </ng-container>
                    <p class="ellipse no-marg">{{element.accountcode}}</p>
                  </td>
                  <td [hidden]="!isTblFooter" class="footer mat-footer-cell" *matFooterCellDef></td>
                </ng-container>
                <!-- Description Column -->
                <ng-container matColumnDef="description">
                  <th class="descrip-col" mat-header-cell *matHeaderCellDef title="Description">Description</th>
                  <td class="descrip-col" mat-cell *matCellDef="let element" title="{{element.accountname}}"><p class="ellipse no-marg">{{element.accountname}}</p></td>
                  <td [hidden]="!isTblFooter" class="footer mat-footer-cell" *matFooterCellDef></td>
                </ng-container>

                <!-- Leadsheet Column -->
                <ng-container matColumnDef="leadsheet">
                  <th class="sheet-col" mat-header-cell *matHeaderCellDef title="Leadsheet">Leadsheet</th>
                  <td class="sheet-col" mat-cell *matCellDef="let element" title="{{element.leadsheetcode}}"><p class="ellipse no-marg">{{element.leadsheetcode}}</p></td>
                  <td [hidden]="!isTblFooter" class="footer mat-footer-cell" *matFooterCellDef></td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;" [ngClass]="{'firstTableBorder': row.highlight}"></tr>
                <tr mat-footer-row class="first-footer-border" *matFooterRowDef="displayedColumns; sticky: true"></tr>
              </table>
            </div>
          </li>
        </ul>
      </div>
      <div class="daily-loads-changes-items">
        <ul>
          <li *ngFor="let dateItem of datesData; let i = index" [ngClass]="{'border-primary border-top-0 border-bottom-0': i==0}">
            <div class="daily-loads-header">
              <div class="daily-loads-header-wrap">
                <div class="daily-loads-year-label" title="As of {{dateItem.recieveddate}}">
                  As of <span>{{dateItem.recieveddate}}</span>
                </div>
                <div class="daily-loads-status flex-box-col flex-box-vc-hl pt-1" *ngIf="dateItem.auditorstatus == 5 || dateItem.auditorstatus ==6"
                    [ngClass]="{'load-accepted': dateItem.auditorstatus == '5', 'load-rejected': dateItem.auditorstatus == '6'}">
                  <!-- If the user accepts, the status UI starts Here -->
                  <button mat-button class="button-text" [matMenuTriggerFor]="menu">
                    <span class="flexbox-row gap-8">
                        <i class="fa-regular fa-check text-success" *ngIf="dateItem.auditorstatus == 5"></i>
                        <i class="fa-regular fa-xmark text-error" *ngIf="dateItem.auditorstatus == 6"></i>
                        <i class="fa-solid fa-angle-down fs-15"></i>
                    </span>
                  </button>
                  <mat-menu #menu="matMenu" #beforeMenu="matMenu" xPosition="before">
                    <div (click)="$event.stopPropagation()">
                      <h5 class="title p-2 border-bottom">
                        {{dateItem.auditorstatus == 5 ? 'Accepted' : dateItem.auditorstatus == 6 ? 'Rejected' : '' | uppercase}} by
                      </h5>
                      <div class="partner-view user-list-item p-2">
                        <ngx-avatars class="dl-status-avatar" initialsSize="2" size="24" [name]="dateItem.modifiedby"></ngx-avatars>
                        <div class="item-content">
                          <p class="role">{{dateItem.modifiedby}}</p>
                        </div>
                      </div>
                      <p title="{{dateItem.auditorstatusdate}}" class="p-2 bg-gray-50 text-uppercase vertical-items gap-8 border-top">
                          {{dateItem.auditorstatus == 5 ? 'Accepted ON' : dateItem.auditorstatus == 6 ? 'Rejected ON' : ''}}
                        <span>
                          {{dateItem.auditorstatusdate}}
                        </span>
                      </p>
                    </div>
                  </mat-menu>
                </div>
              </div>
            </div>
            <div class="daily-loads-body">
              <table mat-table [dataSource]="dateItem.data" class="table-countable">
                <!-- Original Column -->
                <ng-container matColumnDef="original">
                  <th class="original-col" mat-header-cell *matHeaderCellDef title="Original">Original</th>
                  <td class="original-col" mat-cell *matCellDef="let element" title="{{element.originalbalance}}">
                    <span class="text-ellipse">{{element.originalbalance}}</span>
                  </td>
                  <td [hidden]="!isTblFooter" class="footer1" mat-footer-cell *matFooterCellDef title="{{dateItem.originaltotal}}">
                    {{dateItem.originaltotal}}
                  </td>
                </ng-container>

                <!-- Revised Column -->
                <ng-container matColumnDef="revised">
                  <th class="revised-col" mat-header-cell *matHeaderCellDef title="Revised">Revised</th>
                  <td class="revised-col" mat-cell *matCellDef="let element" title="{{element.revised}}" [ngClass]="{'text-error fw-medium': i==0 && (element.highlight == 1 || element.highlight == 11), 'text-success fw-medium': i==0 && element.highlight == 10}">
                    <span class="text-ellipse">{{element.revised}}</span>
                  </td>
                  <td [hidden]="!isTblFooter" class="footer1" mat-footer-cell *matFooterCellDef title="{{dateItem.revisedtotal}}" [ngClass]="{'text-error': revisedtotal > 0 }">
                    {{dateItem.revisedtotal}}
                  </td>
                </ng-container>

                <!-- Change Column -->
                <ng-container matColumnDef="change">
                  <th class="change-col" mat-header-cell *matHeaderCellDef title="Change">Change</th>
                  <td class="change-col" mat-cell *matCellDef="let element" title="{{element.change ? element.change : '-'}}">
                    <span class="ellipse no-marg">{{element.change ? element.change : '-'}}</span>
                  </td>
                  <td [hidden]="!isTblFooter" class="footer1" mat-footer-cell *matFooterCellDef title="{{dateItem.chngtotal}}" [ngClass]="{'text-error': changetotal > 0 }">
                    {{dateItem.chngtotal}}
                  </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns1; sticky: true"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns1;" [ngClass]="{'lastTableorder': row.highlight && (datesData && i == 0) }"></tr>
                <tr mat-footer-row class="middle-footer-border" *matFooterRowDef="displayedColumns1; sticky: true"></tr>
              </table>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</div>


<ng-template #rejectDialog>
  <div class="countable-dialog confirmation-dailog changes-rejected-dialog" (click)="$event.stopPropagation()">
    <div mat-dialog-title class="dialog-header">
      <span class="badge badge-warning badge-circle icon-bordered-warning">
        <i class="fa-regular fa-triangle-exclamation text-warning"></i>
      </span>
      <h4 class="title">Changes Rejected</h4>
      <button color="error" class="close" [mat-dialog-close]="false">
        <i class="fa-regular fa-xmark clear-icon"></i>
      </button>
    </div>

    <div mat-dialog-content class="dialog-body-content">
      <p>Trial Balance as per our software is different than Client's Accounting Software.</p>
      <p>Would you still like to reject the changes?</p>
    </div>

    <div mat-dialog-actions class="dialog-footer">
      <button mat-button mat-stroked-button class="button-medium" color="dark"
        [mat-dialog-close]="false">No</button>
      <button mat-button mat-flat-button class="button-medium" color="primary"
        [mat-dialog-close]="true" (click)="saveResponse(6)">Yes</button>
    </div>
  </div>
</ng-template>

<!-- when revised column total is not zero then need to show dialog-box -->
<ng-template #balanceDialogBox>
  <div class="countable-dialog confirmation-dailog changes-rejected-dialog" (click)="$event.stopPropagation()">
    <div mat-dialog-title class="dialog-header">
      <span class="badge badge-warning badge-circle icon-bordered-warning">
        <i class="fa-regular fa-triangle-exclamation text-warning"></i>
      </span>
      <h4 class="title">{{balReconciledTitle | titlecase }}</h4>
      <button color="error" class="close" [mat-dialog-close]="false">
        <i class="fa-regular fa-xmark clear-icon"></i>
      </button>
    </div>

    <div mat-dialog-content class="dialog-body-content">
      <p>Trial Balance Debit & Credit are not equal</p>
      <p>Please review with your client</p>
    </div>

    <div mat-dialog-actions class="dialog-footer">
      <button mat-button mat-flat-button class="button-medium" color="primary"
        [mat-dialog-close]="true">Ok</button>
    </div>
  </div>
</ng-template>
